module.exports = __webpack_public_path__ + "static/media/case3.f3d2558a.jpg";